import { Capacitor } from "@capacitor/core";

export async function initCapacitor(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  const { StatusBar, Style } = await import("@capacitor/status-bar");
  const { Keyboard } = await import("@capacitor/keyboard");

  await StatusBar.setStyle({ style: Style.Light });
  await Keyboard.setAccessoryBarVisible({ isVisible: true });
}
